import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "Immigration Law",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const contactMethods = [
    {
      title: "Call Us",
      value: "+44 (0) 121 630 6635",
      href: "tel:+4401216306635",
      note: "Mon – Fri: 9:00 AM – 5:30 PM",
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
        />
      ),
    },
    {
      title: "Email Us",
      value: "info@blackhorselaw.com",
      href: "mailto:info@blackhorselaw.com",
      note: "We aim to reply within 24 hours",
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
      ),
    },
    {
      title: "Visit Our Office",
      value: "2 Bevington Road, Aston, B6 6JB",
      href: "https://maps.google.com/?q=2+Bevington+Road,+Aston,+Birmingham,+B6+6JB",
      note: "Birmingham, United Kingdom",
      icon: (
        <>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </>
      ),
    },
  ];

  return (
    <>
      {/* Hero Banner matching /our-people */}
      <section className="homepageBanner pt-36 pb-16 lg:pt-52 lg:pb-24">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl">
            <h1 className="mb-6 text-4xl font-bold text-white lg:text-6xl">
              Contact Us
            </h1>
            <p className="text-base leading-7 text-white/90 lg:text-lg">
              Whether you need guidance on UK immigration, family law representation, or tailored legal advice, our experienced team is here to help you move forward.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="bg-light-grey py-12 lg:py-12">
        <div className="container mx-auto px-4">
          {/* Quick Contact Cards */}
          <div className="mb-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {contactMethods.map((method, idx) => (
              <div
                key={idx}
                className="rounded-2xl bg-white p-6 shadow-sm border border-slate-100 flex items-start gap-4 transition duration-200 hover:shadow-md"
              >
                <div className="w-12 h-12 rounded-full bg-[rgb(26,36,58)] text-[#C9A04A] flex items-center justify-center shrink-0">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    {method.icon}
                  </svg>
                </div>
                <div>
                  <h3 className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">
                    {method.title}
                  </h3>
                  <a
                    href={method.href}
                    className="text-base font-bold text-[rgb(26,36,58)] hover:text-[#C9A04A] transition block break-all"
                    target={
                      method.href.startsWith("http") ? "_blank" : undefined
                    }
                    rel={
                      method.href.startsWith("http")
                        ? "noreferrer"
                        : undefined
                    }
                  >
                    {method.value}
                  </a>
                  <p className="text-xs text-slate-500 mt-1">{method.note}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Form and Map Grid */}
          <div className="grid gap-12 lg:grid-cols-12 items-start">
            {/* Left: Contact Form */}
            <div className="lg:col-span-7 bg-white rounded-3xl p-8 sm:p-10 shadow-panel border border-slate-100">
              <span className="inline-block text-[11px] font-bold tracking-widest text-slate-400 uppercase mb-3">
                GET IN TOUCH
              </span>
              <h2 className="text-2xl sm:text-3xl font-bold text-[rgb(26,36,58)] mb-3">
                Send us a message
              </h2>
              <p className="text-sm text-slate-600 mb-8">
                Fill in your details below and a member of our team will contact you promptly to discuss your matter.
              </p>

              {submitted ? (
                <div className="rounded-2xl bg-emerald-50 border border-emerald-200 p-8 text-center">
                  <div className="w-12 h-12 rounded-full bg-emerald-100 text-emerald-600 mx-auto flex items-center justify-center mb-4">
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth={2.5}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <h3 className="text-lg font-bold text-emerald-900 mb-2">
                    Message received!
                  </h3>
                  <p className="text-sm text-emerald-700 max-w-md mx-auto">
                    Thank you for contacting Blackhorse Law. One of our legal specialists will review your enquiry and get back to you shortly.
                  </p>
                  <button
                    type="button"
                    onClick={() => {
                      setSubmitted(false);
                      setFormData({
                        name: "",
                        email: "",
                        phone: "",
                        service: "Immigration Law",
                        message: "",
                      });
                    }}
                    className="mt-6 inline-flex text-xs font-semibold text-emerald-800 underline hover:opacity-80"
                  >
                    Send another enquiry
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid gap-6 sm:grid-cols-2">
                    <div>
                      <label className="block text-xs font-bold text-slate-700 mb-2">
                        Full Name <span className="text-rose-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        required
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="John Doe"
                        className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm focus:border-[#C9A04A] focus:outline-none focus:ring-1 focus:ring-[#C9A04A]"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-bold text-slate-700 mb-2">
                        Email Address <span className="text-rose-500">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="name@example.com"
                        className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm focus:border-[#C9A04A] focus:outline-none focus:ring-1 focus:ring-[#C9A04A]"
                      />
                    </div>
                  </div>

                  <div className="grid gap-6 sm:grid-cols-2">
                    <div>
                      <label className="block text-xs font-bold text-slate-700 mb-2">
                        Phone Number <span className="text-rose-500">*</span>
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        required
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="+44 7123 456789"
                        className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm focus:border-[#C9A04A] focus:outline-none focus:ring-1 focus:ring-[#C9A04A]"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-bold text-slate-700 mb-2">
                        Service Area
                      </label>
                      <select
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                        className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm bg-white focus:border-[#C9A04A] focus:outline-none focus:ring-1 focus:ring-[#C9A04A]"
                      >
                        <option value="Immigration Law">Immigration Law</option>
                        <option value="Family Law">Family Law</option>
                        <option value="Partner & Family Visa">
                          Partner & Family Visa
                        </option>
                        <option value="General Legal Enquiry">
                          General Legal Enquiry
                        </option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-bold text-slate-700 mb-2">
                      Your Message <span className="text-rose-500">*</span>
                    </label>
                    <textarea
                      name="message"
                      required
                      rows={5}
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Please provide details of your matter..."
                      className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm focus:border-[#C9A04A] focus:outline-none focus:ring-1 focus:ring-[#C9A04A]"
                    />
                  </div>

                  <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-2">
                    <p className="text-xs text-slate-500">
                      We treat all information confidentially.
                    </p>
                    <button
                      type="submit"
                      className="w-full sm:w-auto bg-[rgb(26,36,58)] hover:bg-[#C9A04A] text-white font-bold px-8 py-3.5 rounded-full text-sm transition duration-200 shadow-sm"
                    >
                      Send Message &rarr;
                    </button>
                  </div>
                </form>
              )}
            </div>

            {/* Right: Office & Map Card */}
            <div className="lg:col-span-5 space-y-6">
              <div className="bg-white rounded-3xl p-8 shadow-panel border border-slate-100">
                <span className="inline-block text-[11px] font-bold tracking-widest text-slate-400 uppercase mb-3">
                  OUR OFFICE
                </span>
                <h3 className="text-xl font-bold text-[rgb(26,36,58)] mb-3">
                  Birmingham Head Office
                </h3>
                <p className="text-sm text-slate-600 mb-6 leading-relaxed">
                  Located in Aston, Birmingham, our office is easily accessible by public transport and by car with nearby parking facilities.
                </p>

                <div className="space-y-3 border-t border-slate-100 pt-5 text-sm">
                  <div className="flex items-start gap-3">
                    <span className="font-semibold text-[rgb(26,36,58)] shrink-0 w-20">
                      Address:
                    </span>
                    <span className="text-[#C9A04A]">
                      2 Bevington Road, Aston, Birmingham, B6 6JB
                    </span>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="font-semibold text-[rgb(26,36,58)] shrink-0 w-20">
                      Phone:
                    </span>
                    <a
                      href="tel:+4401216306635"
                      className="text-[#C9A04A] font-semibold hover:underline"
                    >
                      +44 (0) 121 630 6635
                    </a>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="font-semibold text-[rgb(26,36,58)] shrink-0 w-20">
                      Email:
                    </span>
                    <a
                      href="mailto:info@blackhorselaw.com"
                      className="text-[#C9A04A] font-semibold hover:underline"
                    >
                      info@blackhorselaw.com
                    </a>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="font-semibold text-[rgb(26,36,58)] shrink-0 w-20">
                      Hours:
                    </span>
                    <span className="text-[#C9A04A]">
                      Monday to Friday: 9:00 AM – 5:30 PM
                    </span>
                  </div>
                </div>

                {/* Google Map Embed */}
                <div className="mt-6 rounded-2xl overflow-hidden border border-slate-200 h-64 w-full">
                  <iframe
                    title="Blackhorse Law Office Location"
                    src="https://maps.google.com/maps?q=2%20Bevington%20Road,%20Aston,%20Birmingham,%20B6%206JB&t=&z=15&ie=UTF8&iwloc=&output=embed"
                    className="w-full h-full border-0"
                    loading="lazy"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;

